<app-spinner></app-spinner>
<div id="container" class="container-fluid e-p-0">
    <router-outlet></router-outlet>
</div>